export enum SampleSizeState {
  Ok = 'OK',
  LowSampleSize = 'LOW_SAMPLE_SIZE',
  NoData = 'NO_DATA',
}
